import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import Loader from 'ui/Loader/Loader';
import { IModalProps } from '../IModalProps';

import styles from './SpinnerModal.module.css';

const modalClassNames = {
  modal: styles.container,
};

const SpinnerModal = ({ open, onClose }: IModalProps) => (
  <Modal
    open={open}
    onClose={onClose}
    closeOnOverlayClick={false}
    showCloseIcon={false}
    closeOnEsc={false}
    center
    role="progressbar"
    classNames={modalClassNames}
  >
    <Loader />
  </Modal>
);

export default SpinnerModal;
